import { Link } from "gatsby"
import React, { useMemo } from "react"
import useButtonStates from "../../hooks/useButtonStates"
import tw from "twin.macro"

const Twitter: React.FC<{
  link: string
  iconContainerStyle?: any
  iconColor?: any
}> = ({ link, iconContainerStyle, iconColor }) => {
  const {
    handleMouseOver,
    handleMouseLeave,
    handleFocus,
    handleBlur,
    handleVisited,
    hover,
    visited,
    focus,
  } = useButtonStates()
  const iconFillColor = useMemo(() => {
    if (iconColor) {
      return hover || focus ? "#E1E6EC" : iconColor
    }
    return hover || focus ? "#385885" : "#fff"
  }, [hover, focus, iconColor])
  const iconCircleColor = useMemo(() => {
    if (iconColor) {
      return "transparent"
    }
    return hover || focus ? "#E1E6EC" : "#385885"
  }, [hover, focus, iconColor])

  return (
    <Link
      to={link}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onClick={handleVisited}
      css={[tw`transition-colors duration-500`]}
      style={{ outline: "none" }}
      className="group"
      aria-label="twitter link"
    >
      <svg
        width="80"
        height="80"
        viewBox="-5 10 80 50"
        xmlns="http://www.w3.org/2000/svg"
        css={
          iconContainerStyle ?? [
            tw`border-2 border-transparent rounded-full group-focus-visible:border-blue-150`,
          ]
        }
      >
        <g fill="none" fillRule="evenodd">
          <circle
            style={{
              transition: hover || focus ? "all 500ms ease" : "all 300ms ease",
            }}
            fill={iconCircleColor}
            cx="35.5"
            cy="35.5"
            r="35.5"
          />
          <path
            style={{
              transition: hover || focus ? "all 500ms ease" : "all 300ms ease",
            }}
            xmlns="http://www.w3.org/2000/svg"
            d="M47.4967 18H53.5705L40.2082 33.3173L56 54H43.679L33.961 41.4519L22.9414 54H16.7809L31.0976 37.7308L16 18H28.6681L37.3449 29.5096L47.4967 18ZM45.3275 50.3654H48.7115L26.846 21.4615H23.2017L45.3275 50.3654Z"
            fill={iconFillColor}
          />
        </g>
      </svg>
    </Link>
  )
}

export default Twitter
